import { subdomainTypes } from "../context/availableSubdomains";

export const getStripeSecretKey = (branch: subdomainTypes | ""): string => {
  switch (branch) {
    case "nz":
      return process.env.REACT_APP_STRIPE_SECRET_KEY_NZ || "";
    case "au":
      return process.env.REACT_APP_STRIPE_SECRET_KEY_AU || "";
    case "ca":
      return process.env.REACT_APP_STRIPE_SECRET_KEY_CA || "";
    default:
      return "";
  }
};
